import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { 
  hasPrintingAccess, 
  hasSubscriptionAccess, 
  getWaitlistStatus,
  WAITLIST_CONFIG 
} from '../config/waitlistConfig';

export const useWaitlist = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  
  const userEmail = user?.email || null;
  
  return {
    // Access checks
    hasPrintingAccess: hasPrintingAccess(userEmail),
    hasSubscriptionAccess: hasSubscriptionAccess(userEmail),
    
    // Status information
    waitlistStatus: getWaitlistStatus(userEmail),
    
    // Configuration
    config: WAITLIST_CONFIG,
    
    // User information
    userEmail,
    isAuthorized: hasPrintingAccess(userEmail),
    isWaitlistMember: !hasPrintingAccess(userEmail)
  };
}; 